import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import styles from "./StoryGridGallery.module.css"
import ContentTitle from "../../sidesheet/ContentTitle";
import ImageModal from "../ImageModal";
import ScrollView from "../../ScrollView";
import DataProvider from "../../../../data_provider/DataProvider";
import { useSearchParams } from "react-router-dom";
import { ListSearchReqBody } from "../../../../data_provider/gateways/MapGateway";
import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";
import { useModal } from "../../../modal/Modal";
import ModalButtons from "../../../modal/ModalButtons";
import icons from "../../../../img/icon/icons";
import { ImageInfo } from "../../../common/Common";


interface GridGalleryProps {
    setIsFullView: Dispatch<SetStateAction<boolean>>;
    xid: number;
    images?: ImageInfo[];
    isCreator:boolean;
    openMapScreenModal?: (modalProps: any) => void; // 지도 화면 모달 열기 함수
    closeMapScreenModal?: () => void; // 지도 화면 모달 닫기 함수
}

/**
 * 플로팅사이드시트 장소 이미지 갤러리
 * @author mjkang
 * @param props {@link GridGalleryProps}
 * @returns GridGallery
 */
const StoryGridGallery = (props: GridGalleryProps) => {
    const [params] = useSearchParams();
    const mapid = useMemo(() => params.get("id") as string, [params]);
    const [imageData, setImageData] = useState<ImageInfo[] | undefined>();
    const [count, setCount] = useState<number>(0);
    const [selected, setSelected] = useState<number>(-1);
    const [showModal, setShowModal] = useState(false);
    const [deletedItem, setDeletedItem] = useState<{ key: string; value: any }>();
    
    // 25.07.10 | Kim Young Jun | 플로팅사이드시트에서 지도 화면 모달 열기/닫기 함수 추가
    const { openMapScreenModal, closeMapScreenModal } = props;
 

    useEffect(() => {
        props.setIsFullView(true);

        return () => {
            props.setIsFullView(false);
        };
    }, []);

    useEffect(() => {
        if (!showModal) setSelected(-1);
    }, [showModal]);

    const { openModal } = useModal();

    const onDeleteImage = (iid:number) => {       
        
        if(props.isCreator){
            openMapScreenModal && openMapScreenModal({
                title:"안내",
                children:"이미지를 삭제하시겠습니까?",
                modalButtons: (
                    <ModalButtons
                        buttonCount={1}
                        buttons={[
                            {label: "취소",color: "Secondary",onClick: () => {closeMapScreenModal && closeMapScreenModal();return;},},
                            {label: "삭제",color: "Danger",onClick: async () => {
                                const formData = new FormData();
                                formData.append("delete",iid.toString());
                                const result = await DataProvider.UpdatePlaceInfo({ mapid: mapid, XID: props.xid.toString()}, formData);
                                if (result.flag) {
                                    setDeletedItem({ key: "IID", value: iid });
                                    closeMapScreenModal && closeMapScreenModal();
                                } else {
                                    // result.status && result.status === 403 && openMapScreenModal && openMapScreenModal({
                                    //     title: "경고",
                                    //     children: "삭제 권한이 없습니다.",
                                    //     modalButtons: ( <ModalButtons buttonCount={1} buttons={[{label: "확인",color: "Danger",onClick: () => {closeMapScreenModal && closeMapScreenModal();},},]}/> ),
                                    // });
                                    // 에러 상황 별 화면 처리

                                    // hmchoi 오류별 처리 구현
                                    switch (result.status) {
                                        case 403:
                                            openModal({title: "오류", children: "이미지를 삭제할 권한이 없습니다." }); break;
                                        case 404:
                                            openModal({title: "오류", children: "이미 삭제되었거나 존재하지 않는 이미지입니다." }); break;
                                        case 500:
                                            openModal({title: "오류", children: "이미지를 처리하는 중 서버 오류가 발생했습니다." }); break;
                                        default:
                                            openModal({ title: "오류", children: result.desc ?? "일시적인 오류가 발생했습니다." });
                                    }

                                    return;
                                }
                                    // setSelectedIdx(-1);
                            },},
                        ]}
                    />
                ),
            })
        }else{
            openMapScreenModal && openMapScreenModal({
                title:"안내",
                children:"삭제 권한이 없습니다.",
                modalButtons: (
                    <ModalButtons
                        buttonCount={1}
                        buttons={[
                            {label: "확인",color: "Primary",onClick: () => {closeMapScreenModal && closeMapScreenModal();return;},},
                        ]}
                    />
                ),
            })
        }
    }

    const renderImages = (image: ImageInfo, idx: number) => {
        const clickImage = () => {
            setShowModal(true);
            setSelected(idx);
            setImageData(props.images);
        };
        return (
            <>
                <div className={styles.imagecontainer}>
                    <img key={idx} src={image.src as string} onClick={clickImage} />
                    <div className={styles.deletebutton} onClick={() => {onDeleteImage(image.id!);}} >
                        <div className={styles.deleteicon} style={{backgroundImage:`url(${icons["trash_white"]})`}}/>
                    </div>        
                </div>
            </>
        
        );
    };

    let newArr = props.images?.map(obj => ({
        url: obj.src as string,
        IID: obj.id as number,
    }));

    if (!newArr) newArr = [];
    

    return (
        <div className={styles.container}>
            <ContentTitle title="사진" count={count} />
            {props.images && props.images.map((image: ImageInfo, index: number) => (
                renderImages(image, index)
            ))}
            {
                imageData && (
                <ImageModal showModal={showModal} setShowModal={setShowModal} images={newArr} selected={selected} setSelected={setSelected} />
            )}
        </div>
    );
};

export default StoryGridGallery;
